import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=1fdc7f06&"
import script from "./Paragraph.vue?vue&type=script&lang=js&"
export * from "./Paragraph.vue?vue&type=script&lang=js&"
import style0 from "./Paragraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports